import { createFeature, createSelector, createReducer, on } from '@ngrx/store';
import { loginSuccess, logout, updateName, updatePref, updateCurrUserDetails } from './auth.actions';

export interface AuthState {
    details: any | null;
    token: string | null;
    refreshToken: string | null;
}

export const initialState: AuthState = {
    details: null,
    token: null,
    refreshToken: null,
};

export const authFeature = createFeature({
    name: 'auth',
    reducer: createReducer(
        initialState,
        on(loginSuccess, (state, { details, token, refreshToken }) => ({ ...state, details, token, refreshToken })),
        on(updatePref, (state, { preference }) => ({ ...state, details: { ...state.details, ...preference } })),
        on(updateName, (state, { name }) => ({ ...state, details: { ...state.details,  ...name } })),
        on(updateCurrUserDetails, (state, { userDetails }) => ({
            ...state,
            details: {
                ...state.details,
                ...userDetails
            }
        })),
        on(logout, () => ({ ...initialState }))
    ),
});

export const { name, reducer, selectAuthState } = authFeature;
export const getDetails = createSelector(selectAuthState, (state) => state.details);
export const getToken = createSelector(selectAuthState, (state) => state.token);
export const getRefreshToken = createSelector(selectAuthState, (state) => state.refreshToken);